export type SdAppRole = "ServiceDesk_Admin" | "ServiceDesk_Agent" | "ServiceDesk_SuperAgent" | "ServiceDesk_User";

/** Service Desk app is mounted at /sd — use for all in-app links */
export const SD_BASE = "/sd";

export function sd(path: string): string {
  if (!path || path === "/") {
    return SD_BASE;
  }
  return `${SD_BASE}${path.startsWith("/") ? path : `/${path}`}`;
}

/** Role ke liye default home path (unauthorized / wrong section) */
export function getDefaultSdPath(role: SdAppRole | null): string {
  if (role === "ServiceDesk_Admin") return `${SD_BASE}/admin`;
  if (role === "ServiceDesk_Agent") return `${SD_BASE}/tickets/project-status`;
  if (role === "ServiceDesk_SuperAgent") return `${SD_BASE}/tickets/project-status`;
  if (role === "ServiceDesk_User") return `${SD_BASE}/my-portal`;
  return `${SD_BASE}/login`;
}

/** Agent `/sd/tickets/:queue` → admin panel equivalent (Admin must not use Stream UI). */
export function mapTicketsQueueToAdminPath(queue?: string): string {
  switch (queue) {
    case "kanban":
      return sd("admin/kanban");
    case "report":
      return sd("admin/report");
    case "project-status":
      return sd("admin/project-status");
    default:
      return sd("admin/tickets");
  }
}
